exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader-wrapper[data-v-71e5b6a1]{z-index:10000;height:100%}.loader-container[data-v-71e5b6a1]{z-index:10001;top:50%;left:50%;transform:translate(-50%,-50%)}.loader[data-v-71e5b6a1]{border-radius:50%;animation:spin-71e5b6a1 2s linear infinite;margin:0 auto;border-style:solid;border-color:#2564f5 #f3f3f3 #f3f3f3}@keyframes spin-71e5b6a1{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports
